module.exports = __webpack_public_path__ + "static/media/AB_K2_2.dd7856a3.jpg";